import type { RootState } from 'state';
import type { RoutesFiltersState } from '../slice';

function getAirportsFrom(state: RootState): RoutesFiltersState['airportsFrom'] {
  const { airportsFrom } = state.flightRoutes.filtersValues;
  return airportsFrom;
}

export default getAirportsFrom;
